import React, { useState } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import DriverVehicleMappingUpdate from "./DriverVehicleMappingUpdate";
import PndRestApi from "src/utils/pnd/PndRestApi";
import { showNotification, successNofication } from "src/shared/components/Notification";
import { Redirect } from 'react-router-dom';
import { ERROR_MESSAGES, PAGE_TIMEOUT } from "src/utils/pnd/PndConstants";

const ModalDriver = ({ modalShow, setModalShow, isTitle, driverData }) => {
    const [isRedirect, setIsRedirect] = useState(false);

    if (isRedirect) {
        window.location.reload();
        return <Redirect to="/web_app/driver-vehicle/view" />;
    }

    const toggle = () => {
        setModalShow(prevState => !prevState);
    }

    const handleSubmit = async (formValues) => {
        try {
            formValues["vehicleId"] = formValues["vehicleId"]["value"] ? formValues["vehicleId"]["value"] : null;
            formValues["driverId"] = formValues["driverId"];
            formValues["assignOrUnAssign"] = true; /** Assign - true, Unassign - false**/

            const response = await PndRestApi.AssignUnAssignVehicleToRider(formValues);
            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    ERROR_MESSAGES.successMessage,
                );
                setTimeout(() => {
                    setIsRedirect(true);
                }, PAGE_TIMEOUT);
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
            }
        } catch (error) {
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        }
    };

    return (
        <div>
            <Modal
                isOpen={modalShow}
                toggle={toggle}
                modalClassName={`ltr-support`}
                className="theme-light ltr-support credit-memo-modal-form-ani"
                style={{ maxWidth: '550px' }}
            >
                <div className="modal__header" style={{ borderBottom: '1px solid #f1f5f9', padding: '16px 20px' }}>
                    <button
                        className="lnr lnr-cross modal__close-btn"
                        aria-label="modal__close-btn"
                        type="button"
                        onClick={toggle}
                        style={{ top: '16px', right: '20px' }}
                    />
                    <h4 className="text-modal modal__title mt-1 text-uppercase" style={{ fontWeight: 800, fontSize: '1.1rem', color: '#6d28d9', letterSpacing: '-0.5px' }}>
                        {isTitle}
                    </h4>
                </div>
                <ModalBody className="p-0">
                    <DriverVehicleMappingUpdate
                        driverData={driverData}
                        onSubmit={handleSubmit}
                    />
                </ModalBody>
            </Modal>
        </div>
    );
};

export default connect((state) => ({
    rtl: state.rtl,
}))(ModalDriver);
